import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubTaskCompleted = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17.588,
	height: 17.393,
	viewBox: "0 0 17.588 17.393",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_7679",
		"data-name": "Group 7679",
		transform: "translate(0.11 0.313)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_9993",
			"data-name": "Group 9993",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_8656",
				"data-name": "Path 8656",
				d: "M14.544,9.7v7.591H.5V3.25H9.264",
				transform: "translate(-0.11 -0.714)",
				fill: "#eeeef9",
				stroke: "#7284fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}), /* @__PURE__ */ _jsx("path", {
				id: "Path_8655",
				"data-name": "Path 8655",
				d: "M17.654.5,7.9,12.594,4,8.692",
				transform: "translate(-0.879 -0.11)",
				fill: "#eeeef9",
				stroke: "#7284fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})]
		})
	})
});
export default SvgSubTaskCompleted;
